/* eslint-disable */
import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { boardLocationState } from '../atoms'
import { pageNumState } from '../atoms'
import { select01State } from '../atoms'
import { select02State } from '../atoms'
import { searchTxtState } from '../atoms'
import { noticeScrollState } from '../atoms'
import { employScrollState } from '../atoms'
export default function Board(props){
  let navigate = useNavigate()
  let location = useLocation()
  // recoilState
  let [boardLocation, setBoardLocation] = useRecoilState(boardLocationState)
  let [pageNum, setPageNum] = useRecoilState(pageNumState)
  let [select01, setSelect01] = useRecoilState(select01State)
  let [select02, setSelect02] = useRecoilState(select02State)
  let [searchTxt, setSearchTxt] = useRecoilState(searchTxtState)
  let [noticeScroll, setNoticeScroll] = useRecoilState(noticeScrollState)
  let [employScroll, setEmployScroll] = useRecoilState(employScrollState)
  // useState
  let [sliceList, setSliceList] = useState([])
  // useEffect
  useEffect(() => {
    sliceFn(props.list)
    // 기존 board 아니면 recoil 초기화
    if(!location.pathname.includes(boardLocation) || boardLocation.trim() == ''){
      setBoardLocation('')
      setPageNum(0)
      setSelect01('전체')
      setSelect02('제목')
      setSearchTxt('')
    }else{
      searchFn(select01, select02, searchTxt)
    }
  }, [])
  // fn
  let sliceFn = (a) => {
    let arr = []
    for(let i=0; i<a.length; i+= 10){
      arr.push(a.slice(i, i + 10))
    }
    setSliceList(arr)
  }
  let searchFn = (s01, s02, txt) => {
    let arr = [...props.list]
    if(s01 != '전체'){
      if(s02 == '제목'){
        sliceFn(arr.filter(a => a.title.includes(txt.trim()) && s01 == a.classification))
      }
      if(s02 == '내용'){
        sliceFn(arr.filter(a => a.content.includes(txt.trim()) && s01 == a.classification))
      }
    }else{
      if(s02 == '제목'){
        sliceFn(arr.filter(a => a.title.includes(txt.trim())))
      }
      if(s02 == '내용'){
        sliceFn(arr.filter(a => a.content.includes(txt.trim())))
      }
    }
    if(sliceList.length > pageNum){
      setPageNum(0)
    }
  }
  // html
  return(
    <>
      {/* <h1>1. {boardLocation}</h1>
      <h1>2. {pageNum}</h1>
      <h1>3. {select01}</h1>
      <h1>4. {select02}</h1>
      <h1>5. {searchTxt}</h1> */}
      <div className="searchBox">
        {
          location.pathname.includes('notice') ?
          <select
            value={select01}
            onChange={(e) => {
              setSelect01(e.target.value)
              searchFn(e.target.value, select02, searchTxt)
            }}
          >
            <option>전체</option>
            <option>공지사항</option>
            <option>언론보도</option>
            <option>회사소식</option>
          </select>
          :
          location.pathname.includes('employ') ?
          <select
            value={select01}
            onChange={(e) => {
              setSelect01(e.target.value)
              searchFn(e.target.value, select02, searchTxt)
            }}
          >
            <option>전체</option>
            <option>채용중</option>
            <option>채용마감</option>
          </select>
          :
          ''
        }
        <select
          value={select02}
          onChange={(e) => {
            setSelect02(e.target.value)
            searchFn(select01, e.target.value, searchTxt)
          }}
        >
          <option>제목</option>
          <option>내용</option>
        </select>
        <input
          type="text"
          value={searchTxt}
          placeholder="검색어를 입력해 주세요."
          onChange={(e) => {setSearchTxt(e.target.value)}}
          onKeyDown={(e) => {
            if(e.key == 'Enter'){
              searchFn(select01, select02, e.target.value)
            }
          }}
        />
        <button
          className="searchIcon"
          onClick={() => {searchFn(select01, select02, searchTxt)}}
        >
          <div className="searchIconBtm"></div>
          <div className="searchIconTop"></div>
        </button>
      </div>
      <div className="boardTh">
        <div>No.</div>
        <div>분류</div>
        <div>제목</div>
        <div>날짜</div>
      </div>
      <div className="boardList">
        {
          sliceList.length > 0 && sliceList[pageNum].map((a, i) => (
            <button
              key={i}
              onClick={() => {
                // 스크롤값 저장
                if(location.pathname.includes('notice')){
                  setNoticeScroll(document.documentElement.scrollTop)
                }
                if(location.pathname.includes('employ')){
                  setEmployScroll(document.documentElement.scrollTop)
                }
                // detail page 이동
                navigate(`/detail/${location.pathname.split('/')[2] + a.key}`)
                setBoardLocation(location.pathname.split('/')[2])
              }}
            >
              <div>{i + 1}</div>
              <div>
                {
                  a.classification == '채용중' || a.classification == '공지사항' ?
                  <div className="typeBox typeBox01">{a.classification}</div> :
                  a.classification == '채용마감' || a.classification == '언론보도' ?
                  <div className="typeBox typeBox02">{a.classification}</div> :
                  a.classification == '회사소식' ?
                  <div className="typeBox typeBox03">{a.classification}</div> :
                  <div>{a.classification}</div>
                }
              </div>
              {
                select02 == '제목' ?
                <div dangerouslySetInnerHTML={{__html : a.title.replaceAll(searchTxt.trim(), `<span style="color:#f0802b; font-weight:500">${searchTxt.trim()}</span>`)}}></div> :
                <div>{a.title}</div>
              }
              <div>{a.date}</div>
            </button>
          ))
        }
      </div>
      <div className="pagingBox">
        {
          sliceList.length > 0 && sliceList.map((a, i) => (
            <button
              key={i}
              className={`pagingBtn ${i == pageNum ? 'on' : ''}`}
              onClick={() => {setPageNum(i)}}
            >
              {i + 1}
            </button>
          ))
        }
      </div>
    </>
  )
}